<template>

    <div class="login auth-page-card">
        <section class="auth-promise">
            <small>YAXUN SPORTS INTELLIGENCE</small>
            <h2>专业研究，诚信相伴</h2>
            <p>汇聚权威专家观点与真实赛事数据，以严谨分析帮助用户建立更清晰的赛前判断。</p>
            <div class="auth-values"><span>专业</span><span>权威</span><span>诚信</span><span>可盈利参考</span></div>
            <strong><i>✓</i> 不中返还所有球币</strong>
        </section>
        <section class="auth-form-panel">
        <div class="wptop">
        <div class="fxwidth wpheader">
            <div class="hdback" @click="goBack"></div>
            <div class="hdtitle">登录</div>
        </div>

        <div class="headerhd"></div>
        </div>

        <div class="auth-form-heading"><small>WELCOME BACK</small><h1>登录亚讯体育</h1><p>进入您的专业赛事研究中心</p></div>

        <div class="item"><label>
            <input type="text" placeholder="账号" v-model="account" ref="refacc" autocomplete="off" autofocus="autofocus"/>
        </label>
        </div>
        <div class="item"><label>
            <input type="password" placeholder="密码" v-model="password" ref="refpwd" autocomplete="off"/>
        </label></div>
        <div class="item"><label>
            <input type="number" placeholder="验证码" v-model="yzmcode" ref="refcode" autocomplete="off"/>
        </label>
            <YZM @getIdentifyCode="valcode" :changeCode="changeCode" class="yzm" />
        </div>
<!--        <div class="code">-->
<!--            <div class="code_n">-->
<!--            <JcRange status="jcRange_status" :successFun="jcRangeSuccess"></JcRange>-->
<!--            </div>-->
<!--        </div>-->
        <div class="btn">
            <button type="button" @click="tologin">登录</button>
        </div>
        <div class="act">
            没有账号？<router-link to="/register">立即注册</router-link>
        </div>
        </section>
    </div>
</template>

<script>
    // import JcRange from "../components/public/JcRange";
    import YZM from "../components/public/yzcode";
    export default {
        name: "login",
        components: {
            // JcRange,
            YZM
        },
        data() {
            return {
                account: '',
                password: '',
                yzm: '',
                yzmcode: '',
                changeCode: 0,
                formPath: '',
                // jcRange_status: false,
            }
        },
        methods: {
            valcode(data){
                this.yzm = data
            },
            // jcRangeSuccess: function(){
            //     this.jcRange_status = true
            // },
            tologin () {
                let that = this
                // console.log(Math.random())
                // that.changeCode = Math.random()
                //
                // return
                if(that.account === ''){
                    that.$toast('请输入账号')
                    that.$nextTick(() =>{
                        that.$refs.refacc.focus()
                    })
                    return
                }
                if(that.password === ''){
                    that.$toast('请输入密码')
                    that.$nextTick(() =>{
                        that.$refs.refpwd.focus()
                    })
                    return
                }
                if(that.yzmcode === ''){
                    that.$toast('请输入验证码')
                    that.$nextTick(() =>{
                        that.$refs.refcode.focus()
                    })
                    return
                }
                if(that.yzmcode !== that.yzm){
                    that.$toast('验证码不正确')
                    that.yzmcode = ''
                    that.changeCode = Math.random()
                    that.$nextTick(() =>{
                        that.$refs.refcode.focus()
                    })
                    return
                }
                // if(!that.jcRange_status){
                //     this.$toast('请拖动滑块验证')
                //     return
                // }
                that.$toast.loading({
                    message: '登录中',
                    duration: 0,
                    forbidClick: true
                })
                setTimeout(function () {
                    that.$post(that.$api.login, {name: that.account, pwd: that.password}).then(function (res) {
                        //console.log(res)
                        if(res.code === 1) {
                            that.$store.commit('LOGIN', res.data.token)
                            that.$toast.success({
                                message: res.msg,
                                forbidClick: true,
                                onClose: function () {
                                    // if(that.$isMobile())
                                    //     that.$router.replace({path: '/my'})
                                    // else
                                        that.$router.replace(that.$route.query.redirect || '/my')
                                }
                            })
                        }
                        else{
                            that.$toast.fail(res.msg)
                        }
                    })
                }, 30)
            },
            goBack(){
                // let that = this
                this.$router.push({
                    path: '/' //that.formPath === '' ?'/':that.formPath
                })
            },
        },
        beforeRouteEnter(to, form, next){
            next(vm => {
                vm.formPath = form.path
            })
        }
    }
</script>

<style scoped>

</style>
